 <script setup>
import { storeToRefs } from 'pinia'
import { useAuthApi } from '~/composables/api/useAuthApi'

const { t } = useI18n()
const authStore = useAuthStore()
const { isImpersonating, realUser } = storeToRefs(authStore)
const { stopImpersonation } = useAuthApi()
const modal = useCustomModal()

const handleStopImpersonation = async () => {
  const loader = modal.preload()
  try {
    const response = await stopImpersonation()
    // response = { accessToken, refreshToken, user: { id, email } }
    authStore.setTokens({
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken
    })
    // Recargar datos completos del usuario y permisos
    await authStore.fetchUser()
    await authStore.loadPermissions()
  } catch {
    // Si falla al terminar la impersonación, limpiar todo y enviar a login
    authStore.clearAuth()
    await navigateTo('/login')
  } finally {
    loader.close()
  }
}
</script>

<template>
  <div
    v-if="isImpersonating"
    class="bg-amber-500 text-white px-4 py-2 flex items-center justify-between"
  >
    <span class="flex items-center gap-2">
      <Icon name="mdi:account-switch" class="w-5 h-5" />
      {{ t('impersonation.banner') }}
      <span v-if="realUser" class="text-amber-100 text-sm">
        ({{ realUser.email }})
      </span>
    </span>
    <button
      class="text-white hover:text-amber-100 underline text-sm"
      @click="handleStopImpersonation"
    >
      {{ t('impersonation.stop') }}
    </button>
  </div>
</template>
